export default "__VITE_ASSET__Dipsyirw__"